module.exports = __webpack_public_path__ + "static/media/holy-blood.af8f135e.png";